// src/reducers/tataReducers.js
import {
  GET_ALL_TATA_RECORDS_REQUEST,
  GET_ALL_TATA_RECORDS_SUCCESS,
  GET_ALL_TATA_RECORDS_FAIL,
  GET_ALL_TATA_RECORDS_RESET,

  GET_TATA_RECORD_BY_ID_REQUEST,
  GET_TATA_RECORD_BY_ID_SUCCESS,
  GET_TATA_RECORD_BY_ID_FAIL,
  GET_TATA_RECORD_BY_ID_RESET,

  CREATE_TATA_RECORD_REQUEST,
  CREATE_TATA_RECORD_SUCCESS,
  CREATE_TATA_RECORD_FAIL,
  CREATE_TATA_RECORD_RESET,

  UPDATE_TATA_RECORD_REQUEST,
  UPDATE_TATA_RECORD_SUCCESS,
  UPDATE_TATA_RECORD_FAIL,
  UPDATE_TATA_RECORD_RESET,

  DELETE_TATA_RECORD_REQUEST,
  DELETE_TATA_RECORD_SUCCESS,
  DELETE_TATA_RECORD_FAIL,
  DELETE_TATA_RECORD_RESET,

  BULK_DELETE_TATA_RECORDS_REQUEST,
  BULK_DELETE_TATA_RECORDS_SUCCESS,
  BULK_DELETE_TATA_RECORDS_FAIL,
  BULK_DELETE_TATA_RECORDS_RESET,

  CLEAR_ALL_TATA_RECORDS_REQUEST,
  CLEAR_ALL_TATA_RECORDS_SUCCESS,
  CLEAR_ALL_TATA_RECORDS_FAIL,
  CLEAR_ALL_TATA_RECORDS_RESET,

  IMPORT_TATA_RECORDS_REQUEST,
  IMPORT_TATA_RECORDS_SUCCESS,
  IMPORT_TATA_RECORDS_FAIL,
  IMPORT_TATA_RECORDS_RESET,

  IMPORT_TATA_PROGRESS_UPDATE,
  IMPORT_TATA_PROGRESS_RESET,

  EXPORT_TATA_RECORDS_REQUEST,
  EXPORT_TATA_RECORDS_SUCCESS,
  EXPORT_TATA_RECORDS_FAIL,
  EXPORT_TATA_RECORDS_RESET,

  GET_TATA_STATS_REQUEST,
  GET_TATA_STATS_SUCCESS,
  GET_TATA_STATS_FAIL,
  GET_TATA_STATS_RESET,

  GET_TATA_BY_FILTERS_REQUEST,
  GET_TATA_BY_FILTERS_SUCCESS,
  GET_TATA_BY_FILTERS_FAIL,
  GET_TATA_BY_FILTERS_RESET,
} from '../constants/tataConstants';

// Get All TATA Records Reducer
export const getTataRecordsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_TATA_RECORDS_REQUEST:
      return { loadingGetTataRecords: true };
    case GET_ALL_TATA_RECORDS_SUCCESS:
      return {
        loadingGetTataRecords: false,
        getTataRecordsData: action.payload,
      };
    case GET_ALL_TATA_RECORDS_FAIL:
      return {
        loadingGetTataRecords: false,
        errorGetTataRecords: action.payload,
      };
    case GET_ALL_TATA_RECORDS_RESET:
      return {};
    default:
      return state;
  }
};

// Get TATA Record By ID Reducer
export const getTataRecordByIdReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_TATA_RECORD_BY_ID_REQUEST:
      return { loadingGetTataRecordById: true };
    case GET_TATA_RECORD_BY_ID_SUCCESS:
      return {
        loadingGetTataRecordById: false,
        getTataRecordByIdData: action.payload,
      };
    case GET_TATA_RECORD_BY_ID_FAIL:
      return {
        loadingGetTataRecordById: false,
        errorGetTataRecordById: action.payload,
      };
    case GET_TATA_RECORD_BY_ID_RESET:
      return {};
    default:
      return state;
  }
};

// Create TATA Record Reducer
export const createTataRecordReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_TATA_RECORD_REQUEST:
      return { loading: true };
    case CREATE_TATA_RECORD_SUCCESS:
      return { loading: false, success: true, record: action.payload };
    case CREATE_TATA_RECORD_FAIL:
      return { loading: false, error: action.payload };
    case CREATE_TATA_RECORD_RESET:
      return {};
    default:
      return state;
  }
};

// Update TATA Record Reducer
export const updateTataRecordReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_TATA_RECORD_REQUEST:
      return { loadingUpdateTataRecord: true };
    case UPDATE_TATA_RECORD_SUCCESS:
      return {
        loadingUpdateTataRecord: false,
        updateTataRecordData: action.payload,
      };
    case UPDATE_TATA_RECORD_FAIL:
      return {
        loadingUpdateTataRecord: false,
        errorUpdateTataRecord: action.payload,
      };
    case UPDATE_TATA_RECORD_RESET:
      return {};
    default:
      return state;
  }
};

// Delete TATA Record Reducer
export const deleteTataRecordReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_TATA_RECORD_REQUEST:
      return { loading: true };
    case DELETE_TATA_RECORD_SUCCESS:
      return { loading: false, success: true };
    case DELETE_TATA_RECORD_FAIL:
      return { loading: false, error: action.payload };
    case DELETE_TATA_RECORD_RESET:
      return {};
    default:
      return state;
  }
};

// Bulk Delete TATA Records Reducer
export const bulkDeleteTataRecordsReducer = (state = {}, action) => {
  switch (action.type) {
    case BULK_DELETE_TATA_RECORDS_REQUEST:
      return { loadingBulkDeleteTataRecords: true };
    case BULK_DELETE_TATA_RECORDS_SUCCESS:
      return {
        loadingBulkDeleteTataRecords: false,
        bulkDeleteTataRecordsData: action.payload,
      };
    case BULK_DELETE_TATA_RECORDS_FAIL:
      return {
        loadingBulkDeleteTataRecords: false,
        errorBulkDeleteTataRecords: action.payload,
      };
    case BULK_DELETE_TATA_RECORDS_RESET:
      return {};
    default:
      return state;
  }
};

// Clear All TATA Records Reducer
export const clearAllTataRecordsReducer = (state = {}, action) => {
  switch (action.type) {
    case CLEAR_ALL_TATA_RECORDS_REQUEST:
      return { loadingClearAllTataRecords: true };
    case CLEAR_ALL_TATA_RECORDS_SUCCESS:
      return {
        loadingClearAllTataRecords: false,
        clearAllTataRecordsData: action.payload,
      };
    case CLEAR_ALL_TATA_RECORDS_FAIL:
      return {
        loadingClearAllTataRecords: false,
        errorClearAllTataRecords: action.payload,
      };
    case CLEAR_ALL_TATA_RECORDS_RESET:
      return {};
    default:
      return state;
  }
};

// Enhanced Import TATA Records Reducer with Progress Tracking
export const importTataRecordsReducer = (state = {}, action) => {
  switch (action.type) {
    case IMPORT_TATA_RECORDS_REQUEST:
      return { 
        loadingImportTataRecords: true,
        importProgress: { progress: 0, processed: 0, total: 0, success: 0, errors: 0 }
      };
    case IMPORT_TATA_RECORDS_SUCCESS:
      return {
        loadingImportTataRecords: false,
        importTataRecordsData: action.payload,
        importProgress: { 
          progress: 100, 
          processed: action.payload.totalRecords || 0, 
          total: action.payload.totalRecords || 0, 
          success: action.payload.successCount || 0, 
          errors: action.payload.errorCount || 0 
        }
      };
    case IMPORT_TATA_RECORDS_FAIL:
      return {
        loadingImportTataRecords: false,
        errorImportTataRecords: action.payload,
      };
    case IMPORT_TATA_RECORDS_RESET:
      return {};
    case IMPORT_TATA_PROGRESS_UPDATE:
      return {
        ...state,
        importProgress: action.payload,
      };
    case IMPORT_TATA_PROGRESS_RESET:
      return {
        ...state,
        importProgress: { progress: 0, processed: 0, total: 0, success: 0, errors: 0 },
      };
    default:
      return state;
  }
};

// Export TATA Records Reducer
export const exportTataRecordsReducer = (state = {}, action) => {
  switch (action.type) {
    case EXPORT_TATA_RECORDS_REQUEST:
      return { loadingExportTataRecords: true };
    case EXPORT_TATA_RECORDS_SUCCESS:
      return {
        loadingExportTataRecords: false,
        exportTataRecordsData: action.payload,
      };
    case EXPORT_TATA_RECORDS_FAIL:
      return {
        loadingExportTataRecords: false,
        errorExportTataRecords: action.payload,
      };
    case EXPORT_TATA_RECORDS_RESET:
      return {};
    default:
      return state;
  }
};

// Get TATA Stats Reducer
export const getTataStatsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_TATA_STATS_REQUEST:
      return { loadingGetTataStats: true };
    case GET_TATA_STATS_SUCCESS:
      return {
        loadingGetTataStats: false,
        getTataStatsData: action.payload,
      };
    case GET_TATA_STATS_FAIL:
      return {
        loadingGetTataStats: false,
        errorGetTataStats: action.payload,
      };
    case GET_TATA_STATS_RESET:
      return {};
    default:
      return state;
  }
};

// Get TATA By Filters Reducer
export const getTataByFiltersReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_TATA_BY_FILTERS_REQUEST:
      return { loadingGetTataByFilters: true };
    case GET_TATA_BY_FILTERS_SUCCESS:
      return {
        loadingGetTataByFilters: false,
        getTataByFiltersData: action.payload,
      };
    case GET_TATA_BY_FILTERS_FAIL:
      return {
        loadingGetTataByFilters: false,
        errorGetTataByFilters: action.payload,
      };
    case GET_TATA_BY_FILTERS_RESET:
      return {};
    default:
      return state;
  }
};

